module.exports={author:"Jos Charles",date:"02/09/2021",publishDate:"11/23/2020",highlighted:!1,tags:"",title:"and"};